// File: /src/constants/apiEndpoints.js

export const API_ENDPOINTS = {
	AUTH: '/auth',
	AUTH_LOGIN: '/auth/login',
	AUTH_REGISTER: '/auth/register',
	AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
	AUTH_RESET_PASSWORD: '/auth/reset-password',
	CLIENTS: '/clients',
	clientById: (clientId) => `/clients/${clientId}`,
	clientColor: (clientId) => `/clients/${clientId}/color`,
	PROJECTS: '/projects',
	projectById: (projectId) => `/projects/${projectId}`,
	INVOICES: '/invoices',
	invoiceById: (invoiceId) => `/invoices/${invoiceId}`,
	USERS_PROFILE: '/users/profile',
	USERS_ME: '/users/user',
	userById: (userId) => `/users/${userId}`,
	USERS_PIX: '/users/pix',
	FINANCE_SUMMARY: '/finance/summary',
	FINANCE_ENTRIES: '/finance/entries',
	FINANCE_ENTRY: '/finance/entry',
	financeEntryById: (entryId) => `/finance/entry/${entryId}`,
	FINANCE_ROOT: '/finance',
	CALENDAR: '/calendar',
	LOGS: '/logs',
	DRIVE_ROOT: '/drive',
	DRIVE_UPLOAD: '/drive/upload',
};

export default API_ENDPOINTS;
